export default "__VITE_ASSET__wHFg$gvM__"